import React, { act, useEffect, useState } from 'react';
import { arrayRemove, arrayUnion, collection, doc, onSnapshot, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ArrowBack from '../components/arrowBack';

export default function PlanBooking() {

  const [facilities, setFacilities] = useState([])
  const [locations, setLocations] = useState("")

  const [facility, setFacility] = useState("")
  const [location, setLocation] = useState("")
  const [groups, setGroups] = useState("")

  const [selectedGroup, setSelectedGroup] = useState("")
  const [list, setList] = useState("")

  const [newUser, setNewUser] = useState("")
  
  const [u, setU] = useState("")

  const [freq, setFreq] = useState("")

  useEffect(() => {
    const getFacilities = onSnapshot(collection(db, "facilities"), (snapshot) => {
      setFacilities(snapshot.docs.map((doc) => (doc.data())));
    });
  }, []);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "locations"), (snapshot) => {
      const collectionData = snapshot.docs.map(doc => doc?.data());

      let loc = collectionData
      let locs = []
      for (let i = 0; i < loc?.length; i++) {
        if (!loc[i]) return
        for (let x = 0; x < Object?.values(loc[i])?.length; x++) {
          locs?.push(Object?.values(loc[i])[x])
        }
      }
      setLocations(locs);
    });
  }, []);

  useEffect(() => {
    if (location) {
      const getGroups = onSnapshot(doc(db, 'groups', facility?.id), (snapshot) => {
        const data = snapshot.data();
  
        let transformedGroups = [];
  
        Object.keys(data).forEach((groupId) => {
          const group = data[groupId];
  
          if (group.days.length > 1 && !group.rnieozdzielenia) {
            group.days.forEach((day) => {
              const newGroup = {
                ...group,
                days: day, 
              };
              transformedGroups.push(newGroup);
            });
          } else {
            const newGroup = {
              ...group,
              days: group.days[0], 
            };
            transformedGroups.push(newGroup);
          }
        });
  
        setGroups(transformedGroups);
      });
    }
  }, [location]);


  const addEvent = async () => {
    const eventDocRef = doc(collection(db, 'planner')); 
    
    await setDoc(db, "planner", eventDocRef?.id, {
      id: eventDocRef.id,
      date: "2024-09-12",
      startTime: u.startTime,
      endTime: u.endTime,
      status: 'scheduled',
      location: u?.location_name,
      minAge: u?.minAge,
      maxAge: u?.maxAge,
      exp: u?.exp,
      color: u?.color,
      name: "lesson"
    }, { merge: true });
  }

    return (

     <div style={({display: "flex", gap: "40px", margin: "3%", width: "97%", marginTop: "20px", flexDirection: "column"})}>
    <h3 style={({fontSize: "18px"})}>Nowy</h3>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>id grupy</h3>
      <input onBlur={(e) => setU({...u, id: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>color</h3>
      <input onBlur={(e) => setU({...u, color: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>name</h3>
      <input  onBlur={(e) => setU({...u, type: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>star time</h3>
      <input onBlur={(e) => setU({...u, startTime: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>end time</h3>
      <input onBlur={(e) => setU({...u, endTime: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>location</h3>
      <input onBlur={(e) => setU({...u, location: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>facility id</h3>
      <input onBlur={(e) => setU({...u, facility_id: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>group id</h3>
      <input onBlur={(e) => setU({...u, groupId: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>instructor</h3>
      <input onBlur={(e) => setU({...u, instructor: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>poziom</h3>
      <input onBlur={(e) => setU({...u, exp: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>min age</h3>
      <input type="number" onBlur={(e) => setU({...u, minAge: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>max age</h3>
      <input type="number" onBlur={(e) => setU({...u, maxAge: e?.target?.value})}/>
    </div>
    <div style={({display: "flex", gap: "10px", flexDirection: "row"})}>
      <h3 style={({fontSize: "18px"})}>miejsca</h3>
      <input type="number" onBlur={(e) => setU({...u, slots: e?.target?.value})}/>
    </div>
    <button onClick={() => addEvent()}>Dodaj</button>
  </div>
    );
  }